import React, { FC } from 'react'
import InfoIcon from 'transfix-icons/build/InfoIcon'
import { Box, makeStyles } from 'transfix-ui/core'

const useCarrierLabelStyles = makeStyles(() => ({
  icon: {
    verticalAlign: 'middle',
  },
}))

interface ICarrierLabelProps {
  /**
   * Text of the label
   */
  text: string
  /**
   * Callback once the icon is clicked
   */
  onClick?: () => void
}

export const CarrierLabel: FC<ICarrierLabelProps> = ({ onClick, text }) => {
  const classes = useCarrierLabelStyles()
  const clickHandler = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <Box mt={1} display='flex' alignItems='center'>
      <Box pr={0.75}>{text}</Box>
      <Box onClick={clickHandler}>
        <InfoIcon className={classes.icon} />
      </Box>
    </Box>
  )
}
